const _temp0 = require("./main.webp");
const _temp1 = require("./seattleheights_2.webp");
const _temp2 = require("./seattleheights_32.webp");
module.exports = {
  "main": _temp0,
  "seattleheights_2": _temp1,
  "seattleheights_32": _temp2
}